import { render } from "./DashboardWorkflowCard.vue?vue&type=template&id=4a9a13cc&scoped=true"
import script from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"
export * from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"

import "./DashboardWorkflowCard.vue?vue&type=style&index=0&id=4a9a13cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9a13cc"]])

export default __exports__